export const APP_BRAND_NAME = 'Walter Match'
